import {useEffect, useRef, useState} from "react";

function TextInput(props){

    const input = useRef();
    const [error, setError] = useState(true)
    const [showError, setShowError] = useState(false)

    const validateHandler = () => {
        props.value(false);
        switch(true) {
            case (props.required && (input.current.value.length === 0)):
                setError("Please enter a " + props.label.toLowerCase())
                return
            case (props.required && (!input.current.value.replace(/\s/g, '').length)):
                setError("Please enter a " + props.label.toLowerCase())
                return
            case (input.current.value.length > props.maxLength):
                setError("Please enter a " + props.label.toLowerCase() + " under " + props.maxLength + " characters")
                return
            default:
                setError(false);
                setShowError(false);
                props.value(input.current.value);
                return
        }
    }

    const showErrorHandler = () => {
        validateHandler()
        setShowError(true)
    }

    useEffect(() => {
        if(props.forceValidation){
            showErrorHandler();
        }
    })

    return(
        <>
            <label htmlFor={props.label.toLowerCase().replace(/\s/g, "")} className={"label"}>{props.label}:</label>
            {(error && showError) && <div className={"bubble"}>{error}</div>}
            <input
                defaultValue={props.defaultValue}
                ref={input}
                type="text"
                name={props.label.toLowerCase().replace(/\s/g, "")}
                autoComplete="on"
                maxLength={props.maxLength}
                onBlur={showErrorHandler}
                onChange={validateHandler}
                className={"input"}
                disabled={props.sending}
            />
        </>
    )
}

export default TextInput;